const DEFAULT_REQUEST = { loading: false, fetched: false, error: false }

export function selectBase(state) {
  return state.request
}

export const makeSelectRequest = slice => state => {
  return selectBase(state)[slice] || DEFAULT_REQUEST
}
